import { render, staticRenderFns } from "./PercentileLabel.vue?vue&type=template&id=0ed81960&"
import script from "./PercentileLabel.vue?vue&type=script&lang=ts&"
export * from "./PercentileLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports